
export default {
  name: "TableOfContents",
  props: {
    // [{ number, label, anchor }]
    items: { type: Array, default: () => [] },
  },
};
